
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(856(|6)|(169|238|482|94)4|288|3340|3867|4935|5605|7532|9618)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
